import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconMarketplace(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M7 4C6.44772 4 6 4.44772 6 5C6 5.55228 6.44772 6 7 6H17C17.5523 6 18 5.55228 18 5C18 4.44772 17.5523 4 17 4H7Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 19V14H20C20.3318 14 20.642 13.8354 20.8281 13.5606C21.0141 13.2859 21.0517 12.9367 20.9285 12.6286L18.677 7H5.32297L3.07153 12.6286C2.94829 12.9367 2.98591 13.2859 3.17194 13.5606C3.35797 13.8354 3.66818 14 4 14H5V19C5 19.5523 5.44772 20 6 20H13C13.5523 20 14 19.5523 14 19V14H17V19C17 19.5523 17.4477 20 18 20C18.5523 20 19 19.5523 19 19ZM12 14V18H7V14H12ZM18.523 12L17.323 9H6.67704L5.47704 12H18.523Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
